import React from 'react'
import { css } from 'emotion'
import Pagination, { PaginationProps } from 'antd/es/pagination'
import 'antd/es/pagination/style/css'

import { MAIN_COLORS, NEUTRAL_COLORS } from 'src/shared/ColorStyles'
import { MAIN_FONT } from 'src/shared/TypographyStyles'

type Props = Pick<
  PaginationProps,
  | 'current'
  | 'pageSize'
  | 'total'
  | 'onChange'
  | 'showSizeChanger'
  | 'onShowSizeChange'
  | 'pageSizeOptions'
>

export default function({
  current,
  pageSize,
  total,
  onChange,
  showSizeChanger,
  onShowSizeChange,
  pageSizeOptions
}: Props) {
  const style = `
    -webkit-font-smoothing: antialiased;

    & > .ant-pagination-prev {
      height: 36px;
      line-height: 36px;
      min-width: 36px;
      margin-right: 5px;
    }

    & > .ant-pagination-prev .ant-pagination-item-link {
      border-radius: 5px;
      border: 1px solid ${NEUTRAL_COLORS.G200};
    }

    & > .ant-pagination-item {
      height: 36px;
      line-height: 36px;
      min-width: 36px;
      font-family: ${MAIN_FONT};
      border-radius: 5px;
      border: 1px solid ${NEUTRAL_COLORS.G200};
      margin-right: 5px;
      transition: 0.3s all;
    }

    & > .ant-pagination-item-active {
      border-color: ${MAIN_COLORS.PRIMARY_BLUE};
    }

    & > .ant-pagination-next {
      height: 36px;
      line-height: 36px;
      min-width: 36px;
      margin-right: 5px;
    }

    & > .ant-pagination-next .ant-pagination-item-link {
      border-radius: 5px;
    }
  `

  return (
    <Pagination
      className={`${css(style)}`}
      current={current}
      pageSize={pageSize}
      total={total}
      onChange={onChange}
      showSizeChanger={showSizeChanger}
      onShowSizeChange={onShowSizeChange}
      pageSizeOptions={pageSizeOptions}
    />
  )
}
